angular.module('qkr')
    .directive('merchantInfoHide', (merchantInfoTraitService) => {
        return {
            restrict: 'A',
            scope: {
                mcPerms: '@'
            },
            link (scope, elem, attrs) {
                merchantInfoTraitService.hasTraits(attrs.merchantInfoHide)
                    .then((checkResult) => {
                        if (checkResult) {
                            elem.remove();
                        }
                    })
                    .catch(reason => elem.text("Error: " + reason));
            }
        }
    });


// WEBPACK FOOTER //
// ./src/shared/merchantInfoHide.directive.js